import script from "./ActionSubmenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActionSubmenu.vue?vue&type=script&setup=true&lang=ts"

import "./ActionSubmenu.vue?vue&type=style&index=0&id=6712fe45&lang=css"

const __exports__ = script;

export default __exports__